import { Activity, ArrowDownToLine, Sunrise, Target, TriangleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { formatMoney } from '../../shared/lib/format';
import { useLocale } from '../../shared/lib/i18n/use-locale';
import type { Alert } from './model';

const ICONS = {
  level_hit: ArrowDownToLine,
  target_hit: Target,
  market_open: Sunrise,
  regime_change: Activity,
  system: TriangleAlert,
} as const;

export function AlertIcon({ alert }: { alert: Alert }) {
  const Icon = ICONS[alert.kind];
  return <Icon aria-hidden className="size-4 shrink-0 text-text-3" />;
}

function text(value: unknown): string {
  return typeof value === 'string' ? value : '';
}

export function AlertMessage({ alert }: { alert: Alert }) {
  const { t } = useTranslation();
  const locale = useLocale();
  const p = alert.payload;
  const symbol = alert.symbol ?? '';
  switch (alert.kind) {
    case 'level_hit':
      return (
        <>
          {t('alerts.levelHit', {
            n: alert.level_n ?? 0,
            symbol,
            price: formatMoney(text(p.price) || '0', locale),
          })}
        </>
      );
    case 'target_hit':
      return (
        <>{t('alerts.targetHit', { symbol, price: formatMoney(text(p.target) || '0', locale) })}</>
      );
    case 'market_open':
      return <>{t('alerts.marketOpen')}</>;
    case 'regime_change':
      return (
        <>
          {t('alerts.regimeChange', {
            symbol,
            trend: t(text(p.trend) === 'up' ? 'regime.uptrendLower' : 'regime.downtrendLower'),
          })}
        </>
      );
    case 'system':
      return <>{text(p.message)}</>;
  }
}
